export default "__VITE_ASSET__4fe0815b__"